import {AccommodationProduct, AccommodationRoomDto} from "../model";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import {Product} from "app/shared/model/ProductBase";
import {ProductType} from "app/shared/model/Product";
import { readIsUsedInActivePackage } from "./productDtoHelpers";

export async function getAccommodationProducts(divisionId: number | null = null) {
    const localApi = await getLocalApi();
    const queryUrl = typeof divisionId === "number" ? apiConfig.accommodation_get_all_with_division.replace("{divisionId}", `${divisionId}`) : apiConfig.accommodation_get_all;

    return await localApi.fetchList(`${queryUrl}`,
    mapAccommodationProducts,
    "Failed to fetch accommodation products");
}

export async function getAccommodationRoomProductsByDivision(divisionId: number): Promise<Product[]> {
    const localApi = await getLocalApi();

    const url = apiConfig.accommodation_room_get_all_by_division
        .replace("{divisionId}", String(divisionId));

    return await localApi.fetchList(
        url,
        mapAccommodationRoomToProductOption,
        "Failed to fetch accommodation rooms"
    );
}

function mapAccommodationProducts(accommodationProduct: any):AccommodationProduct{
     const unitTypeIdRaw =
       accommodationProduct.unitTypeId ??
       accommodationProduct.unitType?.id ??
       accommodationProduct.UnitTypeId;
     const unitTypeId =
       unitTypeIdRaw != null && String(unitTypeIdRaw).trim() !== "" && Number(unitTypeIdRaw) > 0
         ? Number(unitTypeIdRaw)
         : undefined;
     const unitTypeText =
       accommodationProduct.unitTypeText ??
       accommodationProduct.unitTypeName ??
       accommodationProduct.unitType?.name ??
       accommodationProduct.UnitTypeName ??
       undefined;
     return {
        id: accommodationProduct.productId,
        name: accommodationProduct.productName,
        minStay: accommodationProduct.minimumStay,
        minAge:accommodationProduct.minimumAge,
         maxAge: accommodationProduct.maximumAge ?? null,
        isCommitted:accommodationProduct.isCommitted,
        isNonCommitted:accommodationProduct.isNonCommitted,
        lastModifiedDate: accommodationProduct.lastModifiedDate,
        lastUpdatedBy: accommodationProduct.lastModifiedBy,
        division: accommodationProduct.divisionId,
        divisionText: accommodationProduct.division,      
        type:  accommodationProduct.type,      
        typeId:  accommodationProduct.typeId,     
        roomCount: accommodationProduct.roomCount ?? null,
        entityUpdate: accommodationProduct.entityUpdate,
        active: accommodationProduct.active,
        decommissionDate: accommodationProduct.decommissionDate ?? accommodationProduct.offeringClosureDate,
        excludedBookingSystemIds: [],
        unitTypeId,
        unitTypeText,
        isUsedInActivePackage: readIsUsedInActivePackage(accommodationProduct),
     }
}

function mapAccommodationRoomToProductOption(dto: AccommodationRoomDto): Product {
    return {
        id: dto.productId,
        code: `Accommodation-${dto.productId}`,
        name: dto.productName?.trim(),
        type: ProductType.Accommodation,
        active: dto.active ?? true,
    } as unknown as Product;
}